<template>
  <div class="project-roles-list px-1 w-100">
    <b-row v-if="Array.isArray(jobs)" class="px-3">
      <b-col
        v-for="job in jobs"
        :key="job.id"
        cols="12"
        :md="layout === 'vertical' ? 12 : 4"
        :class="{ 'px-2': true, 'py-2': layout === 'vertical' }"
      >
        <job-item
          :job="job"
          :matchedJob="matchedJob"
          :isProjectDisplay="isProjectDisplay"
          :layout="cardLayout"
        />
      </b-col>
      <b-col class="px-2" v-if="layout !== 'vertical' && jobs.length < 3" cols="12" :md="layout === 'vertical' ? 12 : (12 - 4 * jobs.length)">
        <b-card
          class="h-100 p-5 text-center d-flex flex-column justify-content-center align-items-center"
          style="min-height: 260px"
          no-body
        >
          <div>
            <div v-if="!jobs.length">It looks like we don't have any project role that fits your profile right now.</div>
            <div v-else>It looks like we have {{ jobs.length }} project {{ jobs.length === 1 ? 'role' : 'roles' }} that {{ jobs.length === 1 ? 'fits' : 'fit' }} your profile right now.</div>
            <div>To see more we recommend you to <b-link :to="{ name: 'ProfileEdit' }">keep your profile upadated</b-link></div>
            <div>or</div>
            <div>You can visit the <b-link :to="{ name: 'ProjectsIndex' }">projects page for all the internal project roles</b-link></div>
          </div>
        </b-card>
      </b-col>
      <b-col v-else-if="layout === 'vertical' && jobs.length < 1" class="p-2" cols="12">
        <b-card
          class="h-100 p-5 text-center d-flex flex-column justify-content-center align-items-center"
          style="min-height: 260px"
          no-body
        >
          <div>
            <div class="mb-2">It looks like we don't have any mentors that could help you prepare for this job right now.</div>
            <div>You can visit the <b-link :to="{ name: 'MentorsIndex' }">mentors page to checkout all the available mentors</b-link>.</div>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" class="px-2">
        <b-button
          class="float-right mt-3 px-4"
          variant="outline-primary"
          :to="{ name: 'ProjectsIndex' }"
        >View All</b-button>
      </b-col>
    </b-row>
    <b-row v-else class="my-5">
      <b-col cols="12">
        <div class="text-center text-muted">
          No matching project roles found.<br>
          <b-link :to="{ name: 'ProjectsIndex' }">See all projects</b-link>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import JobItem from '@/components/jobs/UserMatchListItem.vue';

export default {
  props: {
    jobs: {
      type: Array,
      default: () => [],
    },
    layout: {
      type: String,
      default: 'horizontal'
    },
    cardLayout: {
      type: String,
      default: 'tiny'
    },
    matchedJob: {
      type: Object,
      default: () => null,
    },
    isProjectDisplay: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    JobItem,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/SuggestedProjectJobs.vue